// $(document).on('click', '.filter-tabs', function () {
//     var dataFilter = $(this).attr('data-filter');
//     var inputElements = $(".fl-checkbox").find('input[name="filter.p.tag"]');
//     var clearFilter = $('.active-facets').children().length > 1;
//     console.log("clearFilter" , clearFilter);
//     var isChecked = false;

//     inputElements.each(function () {
//         if ($(this).val() === dataFilter) {
//             if ($(this).prop('checked')) {
//                 $(this).prop('checked', false).trigger('change');
//                 console.log("Unchecked:", $(this).val());
//             } else {
//                 $(this).prop('checked', true).trigger('change');
//                 console.log("Checked:", $(this).val());
//                 isChecked = true;
//             }
//         }
//     });
//    if (clearFilter){
//       console.log("clearFilter" , clearFilter);
//       $('.active-facets .clear_filters').trigger("click");
//         setTimeout(function() {
//           $(".main--grids").empty();
//           $(".main--grids").append('<div class="empty_element">Product Not Found</div>');
//           $(".infinitpaginOuter").empty();
//         }, 500);
//     }
//     if (isChecked) {
//         $(this).addClass('active');
//         $(dataFilter).addClass('active');
//     } 
//     else {
//         $(this).removeClass('active');
//         $(dataFilter).removeClass('active');
//     }
// });

$(document).ready(function () {

    // 🔥 Normalize function (handles nbsp + extra spaces)
    function normalizeString(str) {
        return (str || '')
            .replace(/&nbsp;/g, ' ')   // handle HTML entity
            .replace(/\u00A0/g, ' ')   // handle NBSP char
            .replace(/\s+/g, ' ')      // collapse spaces
            .trim()
            .toLowerCase();            // avoid case mismatch
    }

    $(".filter-tabs").each(function () {
        var dataFilter = normalizeString($(this).attr('data-filter'));
        var inputElements = $(".fl-checkbox").find('input[name="filter.p.tag"]');
        var hasMatch = false;

        inputElements.each(function () {
            var inputVal = normalizeString($(this).val());

            if (inputVal === dataFilter) {
                hasMatch = true;
            }
        });

        // Optional: hide tabs with no match
        if (!hasMatch) {
            $(this).hide();
        }
    });

    $(document).on('click', '.filter-tabs', function () {
        var dataFilter = normalizeString($(this).attr('data-filter'));
        var inputElements = $(".fl-checkbox").find('input[name="filter.p.tag"]');
        var isChecked = false;

        inputElements.each(function () {
            var inputVal = normalizeString($(this).val());

            if (inputVal === dataFilter) {

                if ($(this).prop('checked')) {
                    $(this).prop('checked', false).trigger('change');
                } else {
                    $(this).prop('checked', true).trigger('change');
                    isChecked = true;
                }
            }
        });

        if (isChecked) {
            $(this).addClass('active');
        } else {
            $(this).removeClass('active');
        }
    });
});


// 🔹 Clear all filters (UI reset)
$(document).on('click', '.clear_filters', function () {
    $(".main-filter-tabs").find(".filter-tabs").removeClass('active');
});


// 🔹 Remove active state when filter removed
$(document).on('click', '.filter-applied', function () {

    function normalizeString(str) {
        return (str || '')
            .replace(/&nbsp;/g, ' ')
            .replace(/\u00A0/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();
    }

    var dataFilter = normalizeString($(this).attr('data_value'));

    $(".main-filter-tabs")
        .find('.filter-tabs')
        .each(function () {
            var tabFilter = normalizeString($(this).attr('data-filter'));

            if (tabFilter === dataFilter) {
                $(this).removeClass('active');
            }
        });
});
// show filter tabs with JSON data
// $(document).ready(function () {
//     let modelFilters = new Set();

//     // Load filters from JSON
//     let modelFiltersData = $("#model-filters-data").text();
//     if (modelFiltersData) {
//         JSON.parse(modelFiltersData).forEach(filter => modelFilters.add(filter.trim()));
//     }

//     function initializeFilters() {
//         let filterContainer = $(".main-filter-tabs").empty();
//         modelFilters.forEach(filter => {
//             if (filter) {
//                 $("<div>", {
//                     class: "filter-tabs",
//                     "data-filter": filter,
//                     text: filter
//                 }).appendTo(filterContainer);
//             }
//         });
//     }

//     function filterProducts() {
//         $(".main-cards").each(function () {
//             let tags = $(this).data("tags") ? $(this).data("tags").split(",") : [];
//             $(this).toggle(tags.some(tag => modelFilters.has(tag.trim())));
//         });
//     }

//     initializeFilters();
//     filterProducts();

//     // Observe for dynamically added products (Infinite Scroll)
//     let observer = new MutationObserver(() => filterProducts());
//     let productList = $(".main--grids")[0];
//     if (productList) {
//         observer.observe(productList, { childList: true });
//     }
// });



// Gift product checkbox – show/hide message field
document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.getElementById('gift-product-checkbox');
  const field = document.querySelector('.gift-message-field');
  const message = document.getElementById('gift-message');

  if (!checkbox || !field) return;

  checkbox.addEventListener('change', function () {
    const isChecked = this.checked;
    field.style.display = isChecked ? 'block' : 'none';
    if (message) message.disabled = !isChecked;
  });
});